import { FC } from 'react'
import { Tabs, TabsProps } from 'antd'
import { translate } from '../../../core'
import { CarouselMainSlideList } from './CarouselMainSlideList'
import { CarouselGroup } from '../type/carousel'

export const CarouselManagement: FC = () => {
  const tabs: TabsProps['items'] = [
    {
      key: CarouselGroup.Watch,
      label: translate('watches'),
      children: <CarouselMainSlideList group={CarouselGroup.Watch} />,
    },
    {
      key: CarouselGroup.Jewelry,
      label: translate('jewelry'),
      children: <CarouselMainSlideList group={CarouselGroup.Jewelry} />,
    },
  ]

  return (
    <Tabs
      defaultActiveKey={CarouselGroup.Watch}
      items={tabs}
    />
  )
}
